export const checkIfItemIsPinned = (
    pinnedItems: string[] = [],
    itemNames: string[],
): boolean => {
    return itemNames.some((name) => pinnedItems.some((item) => item === name));
};
